import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { useBlocker } from '@tanstack/react-router';
import { PasswordInput } from '@Components/inputs/PasswordInput';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import {
  LILI_TERMS_OF_USE_URL,
  SUNRISE_ACCOUNT_MANAGMENT_AGREEMENT_URL,
  SUNRISE_VISA_SAVINGS_EDGE_TERMS_URL,
} from '@Types/consts';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { useCreatePasswordLogic } from './hooks/useUboCreatePasswordLogic';

export const UboCreatePassword = () => {
  const { t } = useTranslation('uboOnboarding');
  const { formMethods, handleSubmit, isLoading } = useCreatePasswordLogic();

  useBlocker({
    shouldBlockFn: ({ next }) => {
      if (next.routeId === routesModel[RoutesMap.INVITE_TEAM_MEMBER_FINISHED].path) return false;
      if (next.routeId === routesModel[RoutesMap.VERIFICATION_FAILED].path) return false;
      if (next.routeId === routesModel[RoutesMap.UBO_ONBOARDING_DOCV].path) return false;
      return true;
    },
  });

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        handleSubmit={async () => await handleSubmit(formMethods.getValues())}
        isLoading={isLoading}
        footerInputSlot={<></>}
        customSubmitTitle={t('createPassword.submit')}
        maxWidth={550}
        shouldStrechCta>
        <div className='flex flex-col items-center justify-center'>
          <Heading.H3 fontWeight={FontWeight.MEDIUM} className='text-center phone:hidden sm:block'>
            {t('createPassword.title')}
          </Heading.H3>
          <Text.H6 fontWeight={FontWeight.SEMIBOLD} className='text-center sm:hidden'>
            {t('createPassword.title')}
          </Text.H6>
          <Text.H9 className='mt-[16px] max-w-[450px] text-center text-text-main-secondary'>
            {t('createPassword.content')}
          </Text.H9>
        </div>
        <div className='mt-[24px] ml-4 max-w-[500px]'>
          <PasswordInput />
        </div>
        <Text.H9 className='mt-[16px] sm:text-center text-text-main-secondary'>
          By clicking Set Password, you agree to the Lili App Inc.
          <br className='phone:hidden sm:block' />
          <a
            href={LILI_TERMS_OF_USE_URL}
            className='text-text-brand-primary  ml-1 underline'
            target='_blank'
            rel='noopener noreferrer'>
            {t('createPassword.termsOfUse', 'Terms of Use')}
          </a>
          ,{' '}
          <a
            href={SUNRISE_ACCOUNT_MANAGMENT_AGREEMENT_URL}
            className='text-text-brand-primary underline'
            target='_blank'
            rel='noopener noreferrer'>
            {t('createPassword.termsAndConditions', 'Terms & Conditions')}
          </a>
          , and{' '}
          <a
            href={SUNRISE_VISA_SAVINGS_EDGE_TERMS_URL}
            className='text-text-brand-primary underline'
            target='_blank'
            rel='noopener noreferrer'>
            {t('createPassword.visaSavingsEdge', 'Visa SavingsEdge agreement')}
          </a>
          .
        </Text.H9>
        {/* </div> */}
      </StepPageWrapper>
    </FormProvider>
  );
};
